// extracted by mini-css-extract-plugin
export var asideBg = "styles-module--asideBg--YesB3";
export var asideBgLeft = "styles-module--asideBgLeft--vh9g1";
export var asideBgRight = "styles-module--asideBgRight--Z9bC+";
export var img = "styles-module--img--X6BCZ";
export var darkoveBaleni = "styles-module--darkoveBaleni--+WAfl";
export var darkoveBaleniImg = "styles-module--darkoveBaleniImg--K0PGF";
export var petrohrad = "styles-module--petrohrad--ZQyfS";
export var anadyrSection = "styles-module--anadyrSection--GIPpX";
export var petrohradInner = "styles-module--petrohradInner--QWq+f";
export var petrohradImg = "styles-module--petrohradImg--0Rijx";
export var petrohradFront = "styles-module--petrohradFront--uvfAd";
export var petrohradBack = "styles-module--petrohradBack--5dW07";
export var petrohradNote = "styles-module--petrohradNote--nqD8p";